export default __webpack_public_path__ + "static/media/logo-stf.087aca85.svg";